import { useEffect, useState } from "react";
import { X } from "lucide-react";
import SumsubWebSdk from "@sumsub/websdk-react";
import styles from "./KycModal.module.css";
import { useLanguage } from "../LanguageContext";

// Sumsub WebSDK in a modal. The SDK walks the trader through ID + proof of address;
// the status itself comes back through the API (webhook / status sync), so closing
// just asks the parent to refresh.
export default function KycModal({ getAccessToken, theme, onStatusChange, onClose }) {
  const { t, langCode } = useLanguage();
  const [accessToken, setAccessToken] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getAccessToken()
      .then((token) => !cancelled && setAccessToken(token))
      .catch((err) => !cancelled && setError(err.message));
    return () => {
      cancelled = true;
    };
  }, [getAccessToken]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleMessage = (type) => {
    if (
      type === "idCheck.onApplicantSubmitted" ||
      type === "idCheck.onApplicantResubmitted" ||
      type === "idCheck.onApplicantStatusChanged"
    ) {
      onStatusChange();
    }
  };

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={t("port_kyc_title")}
      >
        <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
          <X size={20} />
        </button>
        {error ? (
          <p className={styles.message}>{error}</p>
        ) : accessToken ? (
          <SumsubWebSdk
            accessToken={accessToken}
            expirationHandler={getAccessToken}
            config={{ lang: langCode.toLowerCase(), theme }}
            options={{ addViewportTag: false, adaptIframeHeight: true }}
            onMessage={handleMessage}
            onError={(err) => console.error("Sumsub WebSDK error:", err)}
            className={styles.sdk}
          />
        ) : (
          <p className={styles.message}>{t("port_kyc_loading")}</p>
        )}
      </div>
    </div>
  );
}
